export const MODAL_JUSTIFICATIVA = 'MODAL_JUSTIFICATIVA';
export const modalJustificativa = (modalJustificativa) => ({
  type: MODAL_JUSTIFICATIVA,
  payload: {
    modalJustificativa: modalJustificativa,
  },
});
export const ATUALIZAR_BLOCO_ID = 'ATUALIZAR_BLOCO_ID';
export const atualizablocoID = (blocoId) => ({
  type: ATUALIZAR_BLOCO_ID,
  payload: {
    blocoId: blocoId,
  },
});

export const MODAL_BLOCO = 'MODAL_BLOCO';
export const modalBloco = (modalBloco) => ({
  type: MODAL_BLOCO,
  payload: {
    modalBloco: modalBloco,
  },
});

export const ATUALIZAR_LISTAGEM_BLOCOS = 'ATUALIZAR_LISTAGEM_BLOCOS';
export const atualizarListagemBlocos = (listarBlocos) => ({
  type: ATUALIZAR_LISTAGEM_BLOCOS,
  payload: {
    listarBlocos: listarBlocos,
  },
});

export const CARREGAR_BLOCOS = 'CARREGAR_BLOCOS';
export const carregarBlocos = (carregarBlocos) => ({
  type: CARREGAR_BLOCOS,
  payload: {
    carregarBlocos: carregarBlocos,
  },
});

export const ALTERAR_TEXT_BLOCO = 'ALTERAR_TEXT_BLOCO';
export const alterarBlocoText = (blocoText) => ({
  type: ALTERAR_TEXT_BLOCO,
  payload: {
    blocoText: blocoText,
  },
});

export const MODAL_CONFIRMAR = 'MODAL_CONFIRMAR';
export const modalConfirmar = (modalConfirmar) => ({
  type: MODAL_CONFIRMAR,
  payload: {
    modalConfirmar: modalConfirmar,
  },
});



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/bloco/bloco.action.js